import { Signup } from '@app/_models/signup';
import { Order } from '@app/_models/orders/shared';

export class PaymentSummaryRequest {
  PackageID: string;
  PostalCode: string;
  State: string;
  order: Order = new Order();
  constructor(paymentInfo: any) {
    this.PackageID = paymentInfo.packageID;
    this.PostalCode = paymentInfo.billToZip;
    this.State = paymentInfo.billToState;
    this.order = paymentInfo.order;
  }

}
